import { IAccountChangeStatus, IChangeResult, ISubscriptionCreateArguments, LeadStatus } from 'fitbeat.models';
import { AccountStatus, MarketingAnalyticsEvents } from 'fitbeat.models';
import { IMappedPlan, PaymentService } from 'fitbeat.payment-service';
import { UserProfile } from '../../entities/user/userprofile';
import { UserProfileService } from '../user';
import { IChangeFunction } from './accountstatusmanager';

export class StudioSubscriptionToStudioSubscription implements IChangeFunction {
  public constructor(
    private fromStatus: AccountStatus,
    private toStatus: AccountStatus,
    private analytics: MarketingAnalyticsEvents,
  ) {}

  public async validate(): Promise<IAccountChangeStatus> {
    if (this.fromStatus === 'StudioContract' && this.toStatus === 'StudioContract') {
      return {
        fromStatus: this.fromStatus,
        toStatus: this.toStatus,
        success: false,
        message: 'You are unable to start a studio contract due to already being on a studio contract.',
      };
    }

    if (this.toStatus !== 'StudioContract') {
      return {
        fromStatus: this.fromStatus,
        toStatus: this.toStatus,
        success: false,
        message: 'You are unable to join this plan due to it not being a studio contract.',
      };
    }

    return {
      fromStatus: this.fromStatus,
      toStatus: this.toStatus,
      success: true,
      message: '',
    };
  }

  public async change(
    userProfile: UserProfile,
    currentPlan: IMappedPlan,
    paymentService: PaymentService,
    userProfileService: UserProfileService,
    familyPlanOwnerUserProfileId: string,
    subscriptionCreateOptions: ISubscriptionCreateArguments,
  ): Promise<IChangeResult> {
    if (!subscriptionCreateOptions?.billingStartDate) {
      throw new Error('no billing start date provided');
    }

    userProfile.leadStatus = LeadStatus.Won;
    await userProfileService.updateUserProfile(userProfile.uid, userProfile);
    const subscription = await paymentService.subscribeToPlanWithFreeSchedules(new Date(), subscriptionCreateOptions);

    return {
      data: subscription,
      marketingAnalyticsData: {
        trackingEventName: this.analytics,
      },
    };
  }
}
